/**
 * Application Constants
 *
 * Centralized constants used throughout the application.
 */

import { ALL_PERMISSIONS } from '@/lib/platform/permissions/constants';

// Cache durations (in milliseconds)
export const CACHE_DURATION = {
  CLUBS: 5 * 60 * 1000, // 5 minutes
  USERS: 5 * 60 * 1000, // 5 minutes
  VALUATIONS: 15 * 60 * 1000, // 15 minutes
  PERMISSIONS: 5 * 60 * 1000, // 5 minutes
  PLUGIN_SETTINGS: 5 * 60 * 1000, // 5 minutes
  API_KEYS: 5 * 60 * 1000, // 5 minutes
} as const;

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 25,
  MAX_PAGE_SIZE: 100,
} as const;

// Valuation defaults
export const VALUATION_DEFAULTS = {
  BRAND_POPULARITY: 5,
  BRAND_CSR: 5,
  BRAND_CULTURE: 5,
  BRAND_LOYALTY: 5,
  TV_SIZE_CATEGORY: 'L' as const,
} as const;

// Currency defaults
export const CURRENCY = {
  DEFAULT: 'EUR',
  SUPPORTED: ['EUR', 'USD', 'GBP', 'DKK', 'SEK', 'NOK'] as const,
} as const;

// Roles
// UPDATED: 2025-12-15 - Consolidated to use single source of truth from permissions/constants.ts
export const ROLES = {
  ALL: ALL_PERMISSIONS,
  ADMIN_ONLY: ['admin', 'api', 'audit_log'] as const,
} as const;

// API Rate Limits
export const RATE_LIMITS = {
  API_CALLS_PER_MINUTE: 60,
  API_CALLS_PER_HOUR: 1000,
} as const;

// File Upload Limits
export const FILE_LIMITS = {
  MAX_AVATAR_SIZE_MB: 5,
  MAX_LOGO_SIZE_MB: 5,
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/webp'] as const,
} as const;

// Invitation expiry
export const INVITATION_EXPIRY_DAYS = 7;

// Session timeout
export const SESSION_TIMEOUT_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

// Demo Mode
export const DEMO_MODE = {
  ORGANIZATION_ID: 'demo-org-2025',
  UPGRADE_URL: 'https://valiyou.com/pricing',
} as const;

// Feature flags (can be moved to database later)
export const FEATURES = {
  ENABLE_API_ACCESS: true,
  ENABLE_PLUGINS: true,
  ENABLE_AI_INSIGHTS: true,
  ENABLE_AUDIT_LOGS: true,
  ENABLE_MULTI_CURRENCY: true,
} as const;
